import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './ContactSection.css';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    correo: '',
    telefono: '',
    empresa: '',
    mensaje: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const portalId = '1735765';
      const formId = '31fd5863-be40-42d8-8d6b-61ef8455b3ba';
      const region = 'na1';

      // Obtener cookie de seguimiento de HubSpot si está presente
      const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
      };
      const hutk = getCookie('hubspotutk');

      const payload = {
        fields: [
          { name: 'firstname', value: formData.nombre },
          { name: 'lastname', value: formData.apellido },
          { name: 'email', value: formData.correo },
          { name: 'phone', value: formData.telefono },
          { name: 'company', value: formData.empresa },
          { name: 'message', value: formData.mensaje }
        ],
        context: {
          pageUri: window.location.href,
          pageName: document.title || 'Digital Factura - Contacto',
          ...(hutk ? { hutk } : {})
        }
      };

      const response = await fetch(
        `https://api-${region}.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        throw new Error('HubSpot submission failed');
      }

      Swal.fire({
        title: '¡Mensaje Enviado!',
        text: 'Muchas gracias por contactarnos. Un asesor de Digital Factura te contactará en breve.',
        icon: 'success',
        confirmButtonColor: '#C8102E'
      });

      // Limpiar formulario
      setFormData({
        nombre: '',
        apellido: '',
        correo: '',
        telefono: '',
        empresa: '',
        mensaje: ''
      });
    } catch (error) {
      console.error('Error al enviar formulario a HubSpot:', error);
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un problema al enviar tu información. Por favor comunícate a nuestras líneas telefónicas.',
        icon: 'error',
        confirmButtonColor: '#C8102E'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contacto" className="df-contact-section">
      <div className="df-contact-container">
        {/* Columna Izquierda: Información de Contacto */}
        <div className="df-contact-info-col">
          <span className="df-contact-badge">Contáctanos</span>

          <h2 className="df-contact-title">
            <b>¡Contáctanos!</b>
          </h2>

          <p className="df-contact-desc">
            Déjanos tus datos y un asesor de Digital Factura te contactará para ayudarte a elegir la solución ideal para tu negocio.
          </p>

          <div className="df-contact-channels">
            {/* Tarjeta Teléfonos */}
            <div className="df-contact-channel-card">
              <span className="df-contact-channel-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"></path>
                </svg>
              </span>
              <div className="df-contact-channel-details">
                <span className="df-contact-channel-label">LLÁMANOS</span>
                <a href="tel:3336337809" className="df-contact-channel-link">33.3633.7809</a>
                <a href="tel:3336367965" className="df-contact-channel-link">33.3636.7965</a>
                <a href="tel:3336368722" className="df-contact-channel-link">33.3636.8722</a>
              </div>
            </div>

            {/* Tarjeta Correo */}
            <div className="df-contact-channel-card">
              <span className="df-contact-channel-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="3" y="5" width="18" height="14" rx="2"></rect>
                  <path d="M3 7l9 6 9-6"></path>
                </svg>
              </span>
              <div className="df-contact-channel-details">
                <span className="df-contact-channel-label">ESCRÍBENOS</span>
                <a href="mailto:soporte@decaber.com" className="df-contact-channel-link">
                  soporte@decaber.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Columna Derecha: Formulario */}
        <form className="df-contact-form" onSubmit={handleSubmit}>
          <div className="df-form-row">
            <label className="df-form-label">
              Nombre
              <input
                type="text"
                name="nombre"
                required
                className="df-form-input"
                value={formData.nombre}
                onChange={handleChange}
              />
            </label>

            <label className="df-form-label">
              Apellido
              <input
                type="text"
                name="apellido"
                required
                className="df-form-input"
                value={formData.apellido}
                onChange={handleChange}
              />
            </label>
          </div>

          <label className="df-form-label">
            Correo electrónico
            <input
              type="email"
              name="correo"
              required
              className="df-form-input"
              value={formData.correo}
              onChange={handleChange}
            />
          </label>

          <label className="df-form-label">
            Teléfono
            <input
              type="tel"
              name="telefono"
              required
              className="df-form-input"
              value={formData.telefono}
              onChange={handleChange}
            />
          </label>

          <label className="df-form-label">
            Empresa
            <input
              type="text"
              name="empresa"
              className="df-form-input"
              value={formData.empresa}
              onChange={handleChange}
            />
          </label>

          <label className="df-form-label">
            Mensaje
            <textarea
              rows="4"
              name="mensaje"
              className="df-form-textarea"
              value={formData.mensaje}
              onChange={handleChange}
            />
          </label>

          <button
            type="submit"
            className="df-contact-submit-btn"
            disabled={loading}
          >
            {loading ? 'Enviando...' : 'Enviar'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
